import { api_offer_info_path } from '@routes';

import request from './request';
import { OfferOption } from './subscribe';

export interface OfferInfoRequest {
  offer_code: string;
}

export const OFFER_KEY = 'OFFER_KEY';

export const getOfferInfo = async (params: OfferInfoRequest): Promise<OfferOption> => {
  const response = await request('get', api_offer_info_path(params));
  return response;
};
